
import React, { useEffect } from 'react';
// Models
import { IMessage } from 'app/models/ChatAI';
// Hooks
import useParseMarkdownToHTML from './useParseMarkdownToHTML';
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
import { selectLastAnimatedMessageId } from 'app/store/AIChat/AIChat.selectors';
import useHTMLLinkClickHandler from './useHTMLLinkClickHandler';
import useStreamingHtmlAnimation from './useStreamingHTMLAnimations';
import { AIChatActions } from 'app/store/AIChat/AIChat.slice';


interface IProps {
  message: IMessage;
}

export default function RefineMessageText({ message }: IProps) {
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const lastAnimatedMessageId = useAppSelector(selectLastAnimatedMessageId);

  const rawHTML = useParseMarkdownToHTML(message);

  const { containerRef } = useHTMLLinkClickHandler();

  const { displayedHTML, onStart } = useStreamingHtmlAnimation(rawHTML, {
    onEnd: () => {
      dispatch(AIChatActions.setInitialField('lastAnimatedMessageId'));
    }
  });

  useEffect(() => {
    if ( !lastAnimatedMessageId || lastAnimatedMessageId !== message.id ) return;
    onStart();
    // eslint-disable-next-line
  }, [lastAnimatedMessageId]);

  return (
    <div
      className="markdown-text"
      ref={containerRef}
      tabIndex={0}
      dangerouslySetInnerHTML={{ __html: displayedHTML }}
    />
  );
}
